import { Button, Divider, Flex, Modal } from 'antd'
import { useModalDeleteArticleItem } from 'src/pages/budget/budgetCategories/hook'
import {
  closeModalDeleteArticleItem,
  submitDeleteArticleItem,
} from 'src/pages/budget/budgetCategories/model'
import { UiText } from 'src/pages/budget/components'

export const ModalDeleteArticleItem = () => {
  const modalDeleteArticleItemStore = useModalDeleteArticleItem()

  if (!modalDeleteArticleItemStore) return null
  const open = Boolean(modalDeleteArticleItemStore)

  const { articleItem } = modalDeleteArticleItemStore
  const { id, fullNumber, name } = articleItem

  const handleCancel = () => closeModalDeleteArticleItem()
  const handleOk = () => {
    submitDeleteArticleItem({ articleItemId: id })
    closeModalDeleteArticleItem()
  }

  return (
    <Modal
      title={<div style={{ fontSize: 20 }}>Удалить пункт</div>}
      centered
      wrapClassName="ant_modal"
      width={500}
      maskClosable={false}
      open={open}
      destroyOnHidden
      okButtonProps={{ danger: true }}
      onCancel={handleCancel}
      footer={
        <Flex gap={8}>
          <Button size="large" style={{ flex: 1 }} onClick={handleCancel}>
            Отменить
          </Button>
          <Button
            size="large"
            style={{ flex: 1 }}
            danger
            type="primary"
            onClick={handleOk}
          >
            Удалить
          </Button>
        </Flex>
      }
    >
      <Divider />
      <UiText size={18}>
        Вы уверены, что хотите удалить пункт
        <UiText size={18} strong>
          {' '}
          {fullNumber}. {name}
        </UiText>
        ? Это действие нельзя будет отменить, и вам придется заново создавать
        пункт, если вы потом передумаете.
      </UiText>
      <Divider />
    </Modal>
  )
}
